import React from 'react';

import { bemComponent } from '@99designs/frontend-components/utils/app';

interface ContentBodyContainerProps {
    variations?: string[];
    children: React.ReactNode;
    className?: string;
}

const ContentBodyMain = bemComponent('content-body', 'ContentBody');
const ContentBodyInner1 = bemComponent('content-body__inner-1', 'ContentBodyInner1');
const ContentBodyInner2 = bemComponent('content-body__inner-2', 'ContentBodyInner1');

export default function ContentBody({
    children,
    variations = [],
    className,
}: ContentBodyContainerProps) {
    return (
        <ContentBodyMain variations={variations} className={className} data-testid="ContentBody">
            <ContentBodyInner1>
                <ContentBodyInner2>{children}</ContentBodyInner2>
            </ContentBodyInner1>
        </ContentBodyMain>
    );
}
